<template>
  <v-container fluid class="payrollentry-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Payroll Entry</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <p class="text-h5">Create New Payroll Entry</p>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items="employees.filter(x=>x.employeestatus=='Active').map(x => {return {text: x.employeename, value: x._id};})"
                          v-model="payrollentry.employeeid"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Employee"
                          persistent-hint
                          single-line hint="Please choose the employee">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountclass=='Payroll').map(x => {return {text: x.accountname, value: x._id};})"
                          v-model="payrollentry.accountid"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="payrollentry.paydesc"
                          outlined
                          dense
                          placeholder="Description"
                          persistent-hint
                          single-line hint="Enter the description">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-form>
                        <v-menu
                          ref="menu_paydate"
                          v-model="menu_paydate"
                          :close-on-content-click="false"
                          :return-value.sync="payrollentry.paydate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payrollentry.paydate"
                              placeholder="Entry Date"
                              v-bind="attrs"
                              v-bind:value="payrollentry.paydate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Entry Date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payrollentry.paydate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paydate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_paydate.save(payrollentry.paydate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="payrollentry.paycredit"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          v-on:input="checkIncreaseAmount"
                          oninput="if(this.value < 0) this.value = 0;"
                          placeholder="Increase Amount"
                          persistent-hint
                          single-line hint="Increase Amount">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-form>
                        <v-menu
                          ref="menu_postdate"
                          v-model="menu_postdate"
                          :close-on-content-click="false"
                          :return-value.sync="payrollentry.postdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payrollentry.postdate"
                              placeholder="Post Date"
                              v-bind="attrs"
                              v-bind:value="payrollentry.postdate"
                              v-bind:error="errorindex == 3"
                              v-on="on"
                              single-line hint="Post Date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payrollentry.postdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_postdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_postdate.save(payrollentry.postdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="payrollentry.paydebit"
                          v-bind:error="errorindex == 5"
                          v-on:input="checkDecreaseAmount"
                          oninput="if(this.value < 0) this.value = 0;"
                          outlined
                          dense
                          placeholder="Decrease Amount"
                          persistent-hint
                          single-line hint="Decrease Amount">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/payrollentry/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createPayrollEntry()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      payrollentry: {},
      valuetypes: ['Amount', 'Percentage'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      menu_payenddate: null,
      menu_paydate: null,
      menu_postdate: null,
    }
  },

  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    ...mapActions('PayrollEntry', ['insertPayrollEntry','getPayrollEntrysRequest']),
    checkError(){
      if(!this.payrollentry.employeeid){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.payrollentry.accountid){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.payrollentry.paydate){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.payrollentry.postdate){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(this.payrollentry.paycredit==undefined){
        console.log(this.payrollentry.paycredit)
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(this.payrollentry.paydebit==undefined){
        console.log(this.payrollentry.paydebit)
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkIncreaseAmount(){
      if(this.payrollentry.paycredit>0){this.payrollentry.paydebit=0}
    },
    checkDecreaseAmount(){
      if(this.payrollentry.paydebit>0){this.payrollentry.paycredit=0}
    },
    async createPayrollEntry() {
      if(!this.checkError()) return;
      await this.insertPayrollEntry(this.payrollentry);
      router.push('/payrollentry/list');
    },
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
    ...mapState('PayrollEntry', ['isReceiving']),
  },
    mounted () {
    if(this.accounts.length==0) this.getAccountsRequest();
    if(this.employees.length==0) this.getEmployeesRequest();
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
